import Vue from 'vue';
import NetworkPlugin from '../plugins/NetworkPlugin';

Vue.use(NetworkPlugin, {
  baseUrl: process.env.VUE_APP_API_URL,
  sessionCookie: process.env.VUE_APP_SESSION_COOKIE || 'sertracen_admin_session',
});
